import { createAccount, updateAccount } from '../utils/api/account'

export default {
  namespaced: true,
  actions: {
    async create({ dispatch }, data) {
      await createAccount(data).catch((e) => {
        dispatch('notifications/flash/create', {
          type: 'error',
          content: e.json || e.message,
        }, { root: true })

        throw e
      })

      await new Promise((s) => setTimeout(s, 5000))

      dispatch('notifications/flash/create', {
        type: 'success',
        content: 'An account request has been created.',
      }, { root: true })
    },
    async update({ dispatch }, data) {
      await updateAccount(data).catch((e) => {
        dispatch('notifications/flash/create', {
          type: 'error',
          content: 'There was an error creating your account request.',
        }, { root: true })

        throw e
      })

      dispatch('notifications/flash/create', {
        type: 'success',
        content: 'Your changes have been passed to our team. Once reviewed your details will be updated accordingly.',
      }, { root: true })
    },
  },
}
